export default __webpack_public_path__ + "static/media/footer_bus.61f62cc5.png";